import Axios from '@/api/http'

/**
 * 添加AI小易
 * */
export function addaimodel(date) {
  return Axios({
    method: 'post',
    url: '/api/addaimodel',
    data: date
  })
}

/**
 * 修改AI小易
 * */
export function updateaimodel(date) {
  return Axios({
    method: 'post',
    url: '/api/updateaimodel',
    data: date
  })
}

/**
 * 删除AI小易
 * */
export function deleteaimodel(date) {
  return Axios({
    method: 'post',
    url: '/api/deleteaimodel',
    data: date
  })
}
/**
 * 根据id查询AI小易
 * */
export function getaimodelbyid(date) {
  return Axios({
    method: 'post',
    url: '/api/getaimodelbyid',
    data: date
  })
}
/**
 * 获取ai名称配置信息
 * */
export function getaimanageconfig(date) {
  return Axios({
    method: 'post',
    url: '/api/getaimanageconfig',
    data: date
  })
}

/**
 * ai小易上传文件
 * */
export function getfilecontent(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getfilecontent',
    data: date
  })
}

/**
 * 新增知识库
 * */
export function addknowledgebase(date) {
  return Axios({
    method: 'post',
    url: '/openapi/addknowledgebase',
    data: date
  })
}

/**
 * 修改知识库
 * */
export function updateknowledgebase(date) {
  return Axios({
    method: 'post',
    url: '/openapi/updateknowledgebase',
    data: date
  })
}

/**
 * 获取单个知识库信息
 * */
export function getknowledgebasebyid(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getknowledgebasebyid',
    data: date
  })
}

/**
 * 删除知识库
 * */
export function deleteknowledgebase(date) {
  return Axios({
    method: 'post',
    url: '/openapi/deleteknowledgebase',
    data: date
  })
}

/**
 * 获取全部知识库列表
 * */
export function getknowledgebaselist(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getknowledgebaselist',
    data: date
  })
}

/**
 * 获取有没有创建个人知识库的权限
 * */
export function getknowledgeper(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getknowledgeper',
    data: date
  })
}

/**
 * 获取个人知识库
 * */
export function getselfknowledgebaselist(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getselfknowledgebaselist',
    data: date
  })
}

/**
 * 增加知识库文件夹
 * */
export function addknowledgefolder(date) {
  return Axios({
    method: 'post',
    url: '/openapi/addknowledgefolder',
    data: date
  })
}

/**
 * 修改知识库文件夹
 * */
export function updateknowledgefolder(date) {
  return Axios({
    method: 'post',
    url: '/openapi/updateknowledgefolder',
    data: date
  })
}

/**
 * 删除知识库文件夹
 * */
export function deleteknowledgefolder(date) {
  return Axios({
    method: 'post',
    url: '/openapi/deleteknowledgefolder',
    data: date
  })
}

/**
 * 获取知识库文件夹
 * */
export function getknowledgefolderlist(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getknowledgefolderlist',
    data: date
  })
}

/**
 * 解析知识库文件
 * */
export function transtovertor(date) {
  return Axios({
    method: 'post',
    url: '/aikl/transtovertor',
    data: date
  })
}

/**
 * 解析文字返回对应ID(AI)
 * */
export function getoptionsbyvoice(date) {
  return Axios({
    method: 'post',
    url: '/api/getoptionsbyvoice ',
    data: date
  })
}
/**
 * 解析文字返回对应ID
 * */
export function getcommandlist(date) {
  return Axios({
    method: 'post',
    url: '/aikl/getcommandlist',
    data: date
  })
}

/**
 * 解析知识库数据表
 * */
export function transapprovalknowledge(date) {
  return Axios({
    method: 'post',
    url: '/openapi/transapprovalknowledge',
    data: date
  })
}

/**
 * 知识库问答前置接口
 * */
export function getquestionknowledge(date) {
  return Axios({
    method: 'post',
    url: '/aikl/getquestionknowledge',
    data: date
  })
}

/**
 * 获取知识库权限
 * */
export function getknowledgepermission(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getknowledgepermission',
    data: date
  })
}

/**
 * 获取文件夹权限
 * */
export function getfolderpermission(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getfolderpermission',
    data: date
  })
}

/**
 * 设置知识库权限
 * */
export function setknowledgepermission(date) {
  return Axios({
    method: 'post',
    url: '/openapi/setknowledgepermission',
    data: date
  })
}

/**
 * ai创表
 * */
export function createaiapproval(date) {
  return Axios({
    method: 'post',
    url: '/api/createaiapproval',
    data: date
  })
}

/**
 * ai填表
 * */
export function getautofillapprovaldata(date) {
  return Axios({
    method: 'post',
    url: '/api/getautofillapprovaldata',
    data: date
  })
}


/**
 * 应用检索
 * */
export function getsampleword(date) {
  return Axios({
    method: 'post',
    url: '/aikl/getsampleword',
    data: date
  })
}
